import { Component } from 'react'
import styles from '~/styles/switch.module.css'

export default class Switch extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'common' ],
		}
	}
	
	public constructor(props) {
		super(props)
		if (this.props.saveToLocalStorage && this.props.onChange) {
			const isOn = this._localStorage(this.props.saveToLocalStorage)
			if (isOn !== null && this.props.isOn !== isOn) {
				this.props.onChange(isOn)
			}
		}
	}
	
	public render(): JSX.Element {
		if (this.props.hasOwnProperty('isOn')) {
			let className = styles.toggle + ' ' + (this.props.isOn ? styles.yes : styles.no)
			if (this.props.isDisabled) {
				className += ' ' + styles.disabled
			}
			if (this.props.isBlueNo && !this.props.isOn) {
				className += ' ' + styles.blueNo
			}
			if (this.props.isGreenYes && this.props.isOn) {
				className += ' ' + styles.greenYes
			}
			return (
				<div
					className={className}
					onClick={this._onClick.bind(this)}
				>
					<div
						className={styles.grip}
					/>
				</div>
			)
		} else {
			return null
		}
	}
	
	private _onClick(): void {
		if (!this.props.isDisabled) {
			if (this.props.onChange) {
				const value = !this.props.isOn
				this.props.onChange(value)
				if (this.props.saveToLocalStorage) {
					this._localStorage(this.props.saveToLocalStorage, value)
				}
			}
		}
	}

	private _localStorage(key: string, value?: any): null | any {
		if (typeof window !== 'undefined' && window.localStorage) {
			try {
				if (typeof value !== 'undefined') {
					window.localStorage.setItem(key, JSON.stringify(value))
				} else {
					const value = window.localStorage.getItem(key)
					return (typeof value === 'string' ? JSON.parse(value) : value)
				}
			} catch(e) {}
		}
	}
}